import { FormActions } from "../../components/common/FormActions";
import { PaymentStatusTag } from "../../components/common/registerUtils";
import {
  createColumn,
  createViewAction,
  formatAmount,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_USSD_LOGS } from "../../utils/urls";

export const useUSSDLogs = () => {
  const tableColumns = () => [
    createColumn("transaction_id", true, "Transaction ID"),
    createColumn("phone_number", true, "Phone Number"),
    createColumn("payment_type", true, "Payment Type"),
    createColumn("amount", false),
    createColumn("status", true),
    createColumn("created_at", false),
    createColumn("actions", false),
  ];

  const tableData = (data) => {
    if (!data) return [];

    return data.map((item) => ({
      transaction_id: item?.transaction_id,
      phone_number: item?.phone_number,
      payment_type: item?.payment_type,
      amount: numberFormat(item.amount),
      status: <PaymentStatusTag status={item.status} />,
      created_at: formatDateTime(item.created_at),
      actions: (
        <FormActions actions={[createViewAction(URL_USSD_LOGS, item?.id)]} />
      ),
    }));
  };

  const tableTotals = (data: any) => {
    const totalAmount = data?.results?.reduce(
      (acc, item) => acc + Number(item?.amount || 0),
      0,
    );

    return {
      amount: formatAmount(totalAmount),
    };
  };

  const viewData = (item) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: { message: "No data available" },
          },
        ],
      };
    }

    return {
      sections: [
        {
          title: "USSD log Details",
          fields: {
            id: item?.id,
            transaction_id: item?.transaction_id,
            phone_number: item?.phone_number,
            payment_type: item?.payment_type,
            amount: formatAmount(item.amount),
            status: <PaymentStatusTag status={item.status} />,
            created_at: formatDateTime(item.created_at),
          },
        },
      ],
    };
  };

  return {
    tableData,
    tableColumns,
    viewData,
    tableTotals,
  };
};
